import { ref } from 'vue';
import { useToast, TYPE } from 'vue-toastification';
import { useArticleStore } from '@/stores/ArticleStore';

export function useArticleActions() {
  const toast = useToast();
  const articleStore = useArticleStore();

  const showReportModal = ref(false);
  const reportArticleId = ref(null);
  const reportArticleTitle = ref('');
  const reportContent = ref('');
  const formReportErrors = ref({});

  async function copyTitle(title) {
    await navigator.clipboard.writeText(title);
    toast('Título copiado', { type: TYPE.SUCCESS, timeout: 6000 });
  }

  function openReportModal(articleId, articleTitle) {
    reportArticleId.value = articleId;
    reportArticleTitle.value = articleTitle;
    reportContent.value = '';
    formReportErrors.value = {};
    showReportModal.value = true;
  }

  function closeReportModal() {
    showReportModal.value = false;
    reportContent.value = '';
    formReportErrors.value = {};
  }

  async function sendReport() {
    formReportErrors.value = {};

    if (!reportContent.value || reportContent.value.trim() === '') {
      formReportErrors.value.content = 'O campo de descrição é obrigatório';
      return;
    }

    const result = await articleStore.reportArticle(reportArticleId.value, reportContent.value);

    if (result.success) {
      toast('Reportado com sucesso', { type: TYPE.SUCCESS, timeout: 6000 });
      closeReportModal();
    } else {
      if (result.errors) {
        formReportErrors.value = result.errors;
      }
    }
  }

  return {
    // State
    showReportModal,
    reportArticleTitle,
    reportContent,
    formReportErrors,
    // Methods
    copyTitle,
    openReportModal,
    sendReport
  };
}
